import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateLocation } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for updating a Location.
 */
export const useUpdateLocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call updateLocation.
     * @param {object} params
     * @param {Pella.ProductionRequestAPI.Location['id']} params.id - The ID of the Location to update.
     * @param {Pella.ProductionRequestAPI.UpdateLocationInput} params.input - The inputs for updating the Location.
     */
    mutationFn: ({ id, input }) => updateLocation(id, input),
    onSuccess: () => {
      toast.dismiss();
      toast.success('Location updated successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.LOCATION_DATA] });
    },
  });
};
